import type { NotificationsStore } from '@/stores/global/RootStore/NotificationsStore';
import { ILocalStore } from '@/stores/interfaces/ILocalStore';

import { InsightQuickCaptureStore } from './InsightQuickCaptureStore';
import { NoteQuickCaptureStore } from './NoteQuickCaptureStore';

type QuickThoughtsStoreParams = {
  organizationId: string;
  notificationsStore: NotificationsStore;
};

export class QuickThoughtsStore implements ILocalStore {
  readonly note: NoteQuickCaptureStore;
  readonly insight: InsightQuickCaptureStore;

  constructor({ organizationId, notificationsStore }: QuickThoughtsStoreParams) {
    this.note = new NoteQuickCaptureStore({ organizationId, notificationsStore });
    this.insight = new InsightQuickCaptureStore({ organizationId, notificationsStore });
  }

  destroy(): void {
    this.note.destroy();
    this.insight.destroy();
  }
}
